export const messages = {
  en: {
    printAssetInventoryInStock: {
      inventoryName: 'Inventory Name',
      inventoryPerson: 'Inventory Person',
      warehouse: 'Warehouse',
      inventoryDate: 'Inventory Date',
      warehouseName: 'Warehouse Name',
      itemType: 'Item Type',
      itemName: 'Item Name',
      specification: 'Specification',
      itemCode: 'Item Code',
      isFixed: 'Is Fixed',
      batchPrice: 'Batch Price',
      originalStock: 'Original Stock',
      afterInventory: 'After Inventory',
      remark: 'Remark',
      warehouseManagerSign: 'Warehouse Manager Sign',
      transferPersonSign: 'Transfer Person Sign',
      time: 'Time'
    }
  },
  zh: {
    printAssetInventoryInStock: {
      inventoryName: '盘点名称',
      inventoryPerson: '盘点人',
      warehouse: '选择仓库',
      inventoryDate: '盘点日期',
      warehouseName: '仓库名称',
      itemType: '物品类型',
      itemName: '物品名称',
      specification: '物品规格',
      itemCode: '物品编码',
      isFixed: '是否是固定物品',
      batchPrice: '批次价格',
      originalStock: '原有库存',
      afterInventory: '盘点后数量',
      remark: '备注',
      warehouseManagerSign: '仓库管理员签字',
      transferPersonSign: '调拨人员签字',
      time: '时间'
    }
  },
  'zh-TW': {
    printAssetInventoryInStock: {
      inventoryName: '盤點名稱',
      inventoryPerson: '盤點人',
      warehouse: '選擇倉庫',
      inventoryDate: '盤點日期',
      warehouseName: '倉庫名稱',
      itemType: '物品類型',
      itemName: '物品名稱',
      specification: '物品規格',
      itemCode: '物品編碼',
      isFixed: '是否是固定物品',
      batchPrice: '批次價格',
      originalStock: '原有庫存',
      afterInventory: '盤點後數量',
      remark: '備註',
      warehouseManagerSign: '倉庫管理員簽字',
      transferPersonSign: '調撥人員簽字',
      time: '時間'
    }
  }
}
